module.exports = __webpack_public_path__ + "img/obj.8fa89f12.png";